export const getCurrentDateInSelectedLocale = (
	timeZone = "America/New_York",
	dateStyle = "ISO",
	locale = "en-us",
	dateFormat = ""
) => {
	const currentDate = new Date();
	const options = { timeZone };
	const isISO = dateStyle === "ISO";
	if (isISO) {
		locale = "en-us";
	} else {
		locale = locale.replace("_", "-").toLowerCase();
		options.dateStyle = dateStyle; // full
		options.calendar = "gregory";
	}

	try {
		const validLocales = Intl.DateTimeFormat.supportedLocalesOf(
			[locale, locale.split("-")[0], "en"],
			{ localeMatcher: "lookup" }
		);
		const validLocale = validLocales[0];
		const formatter = new Intl.DateTimeFormat(validLocale, options);
		let date = formatter.format(currentDate);
		if (isISO) {
			const [month, day, year] = date.split("/");
			return `${year}-${month}-${day}`;
		} else {
			if (dateFormat) {
				date = dateFormat;
				const dateParts = formatter.formatToParts(currentDate);
				["year", "day", "month", "weekday"].forEach((datePart) => {
					date = date.replace(
						`{${datePart}}`,
						(
							dateParts.find((part) => part.type === datePart)?.value || ""
						).replace(/^0+/, "")
					);
				});
			}
			return date;
		}
	} catch (error) {
		console.error(error);
		return getCurrentDateInSelectedLocaleFallback(
			currentDate,
			dateStyle,
			locale,
			options
		);
	}
};

export const getCurrentDateInSelectedLocaleFallback = (
	currentDate,
	dateStyle,
	locale,
	options
) => {
	const isISO = dateStyle === "ISO";
	const date = currentDate.toLocaleDateString(locale, options);
	if (isISO) {
		const [month, day, year] = date.split("/");
		return `${year}-${month}-${day}`;
	} else {
		return date;
	}
};
